<template>
  <div>
    <form @keyup.enter="filter()" @submit.prevent>
      <div class="row pt-3">
        <div class="col-md-4">
          <text-input v-model="searchForm.text" placeholder="Pesquisar por Nome" />
        </div>
        <div class="col-md-4">
          <button type="button" class="btn btn-sm btn-primary mr-3" @click="showFilters = !showFilters">
            <i class="fas fa-filter" /> Mais Filtros
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="filter()">
            <i class="fas fa-search" /> Pesquisar
          </button>
        </div>
      </div>
      <b-collapse v-model="showFilters">
        <!-- <b-row align-h="between">
          <b-col cols="2" class="mt-2 ml-0 mr-0" align-self="center">
            <b-button @click="clear()" block dense size="sm">
              <i class="fas fa-times" /> Limpar Filtro
            </b-button>
          </b-col>
          <b-col cols="2">
            <date-input v-model="searchForm.date_start" alias="Data inicial" />
          </b-col>
          <b-col cols="2">
            <date-input v-model="searchForm.date_end" alias="Data final" />
          </b-col>
          <b-col align-self="center" cols="2">
            <label for="input-live">Status:</label>
            <b-form-select
              @change="filter()"
              class="mb-3"
              size="sm"
              v-model="searchForm.status"
              :options="options"
              required
            ></b-form-select>
          </b-col>
          <b-col>
            <label for="input-live">Modelo:</label>
            <text-input v-model="searchForm.mod" placeholder="Modelo" />
          </b-col>
          <b-col>
            <label for="input-live">Serie:</label>
            <text-input v-model="searchForm.serie" placeholder="Serie" />
          </b-col>

          <b-col class="pr-0">
            <label for="input-live">Número:</label>
            <text-input v-model="searchForm.nNF" placeholder="Número" />
          </b-col>
        </b-row> -->
        <b-row align-h="between">
          <b-col>
            <date-input v-model="searchForm.date_start" @change="filter()" alias="Data inicial" />
          </b-col>
          <b-col>
            <date-input v-model="searchForm.date_end" @change="filter()" alias="Data final" />
          </b-col>

          <b-col align-self="center" cols="2">
            <label for="input-live">Status:</label>
            <b-form-select @change="filter()" class="mb-3" size="sm" v-model="searchForm.status" :options="options"
              required />
          </b-col>
          <b-col>
            <label for="input-live">Modelo:</label>
            <text-input v-model="searchForm.mod" @change="filter()" placeholder="Modelo" />
          </b-col>
          <b-col>
            <label for="input-live">Serie:</label>
            <text-input v-model="searchForm.serie" @change="filter()" placeholder="Serie" />
          </b-col>

          <b-col class="pr-0">
            <label for="input-live">Número:</label>
            <text-input v-model="searchForm.nNF" @change="filter()" placeholder="Número" />
          </b-col>
        </b-row>
        <b-row class="mt-0 pt-0">
          <b-col cols="2" class="mt-2 ml-0 mr-0" align-self="center">
            <b-button @click="clear()" block dense size="sm">
              <i class="fas fa-times" /> Limpar Filtro
            </b-button>
          </b-col>
          <b-col cols="" class="mt-2 ml-0 mr-0" align-self="center">
            <label for="input-live">Tipo:</label>
            <br />

            <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'nfce'"
              :unchecked-value="''" v-model="searchForm.type">
              <small>NFC-e</small>
            </b-form-checkbox>
            <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'nfe'"
              :unchecked-value="''" v-model="searchForm.type">
              <small>NF-e</small>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <br />
      </b-collapse>
    </form>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";

export default {
  components: {},

  data: function () {
    return {
      showFilters: false,
      searchForm: {
        text: null,
        date_start: null,
        date_end: null,
        status: null,
        mod: null,
        serie: null,
        nNF: null,
        type: ["nfce", "nfe"],
      },
      options: [
        {
          value: null,
          text: "Status",
        },

        {
          value: "n",
          text: "NÃO ENVIADA",
        },

        {
          value: "p",
          text: "PROCESSANDO",
        },

        {
          value: "d",
          text: "DENEGADA",
        },

        {
          value: "a",
          text: "AUTORIZADA",
        },

        {
          value: "i",
          text: "INUTILIZADA",
        },
        {
          value: "c",
          text: "CANCELADA",
        },
        {
          value: "r",
          text: "REJEITADA",
        },
      ],
    };
  },

  watch: {
    searchForm: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.$emit("input", this.searchForm);
      },
    },
  },

  methods: {
    clear() {
      this.searchForm.text = null;
      this.searchForm.date_start = null;
      this.searchForm.date_end = null;
      this.searchForm.status = null;
      this.searchForm.mod = null;
      this.searchForm.serie = null;
      this.searchForm.nNF = null;
      this.searchForm.type = ["nfce", "nfe"];

      this.$emit("filter");
    },

    filter() {
      this.$emit("filter");
    },
  },
};
</script>

<style></style>
